// src/components/strumenti/ConsumoClima.js — W442. Consumo e costo di un climatizzatore da EER/COP
import React from "react";
import { useCampi, Campo, Modi, Griglia, Risultato, Formula, Azzera, euro, fmt } from "./UiStrumento";
import { consumoClima } from "../../utils/calcoliStrumenti";

export default function ConsumoClima() {
  const { v, set, n, azzera, setV } = useCampi({ modo:"raff", kw:"", eer:"", ore:"", giorni:"", carico:"60", prezzo:"" });
  const r = consumoClima(n("kw"), n("eer"), n("ore"), n("giorni"), n("carico"), n("prezzo"));
  const sigla = v.modo === "raff" ? "EER" : "COP";
  return (
    <div>
      <Modi settore="condizionamento" valore={v.modo} onChange={(m) => setV(o => ({ ...o, modo:m }))} opzioni={[["raff", "Raffrescamento (EER)"], ["risc", "Riscaldamento (COP)"]]}/>
      <Griglia colonne={2}>
        <Campo etichetta={v.modo === "raff" ? "Potenza frigorifera (kW)" : "Potenza termica (kW)"} valore={v.kw} onChange={set("kw")} placeholder="Es. 3,5"/>
        <Campo etichetta={sigla} valore={v.eer} onChange={set("eer")} placeholder="Es. 3,5" aiuto="Dalla scheda tecnica (o SEER/SCOP per una media stagionale)."/>
        <Campo etichetta="Ore di funzionamento al giorno" valore={v.ore} onChange={set("ore")} placeholder="Es. 8"/>
        <Campo etichetta="Giorni" valore={v.giorni} onChange={set("giorni")} placeholder="Es. 90"/>
        <Campo etichetta="Carico medio (%)" valore={v.carico} onChange={set("carico")} aiuto="Quanto lavora in media rispetto alla piena potenza."/>
        <Campo etichetta="Prezzo energia (€/kWh, facoltativo)" valore={v.prezzo} onChange={set("prezzo")} placeholder="Es. 0,25"/>
      </Griglia>
      <Risultato settore="condizionamento" titolo="Energia elettrica consumata" valore={fmt(r?.kwh, 0)} unita="kWh"
        righe={r ? [["Potenza elettrica a pieno carico", fmt(r.kwElettrici, 2) + " kW"], r.costo !== null && ["Costo", euro(r.costo)]] : []}/>
      <Formula>kW elettrici = kW resi ÷ {sigla}; kWh = kW elettrici × ore × giorni × carico %. Stima indicativa: il rendimento reale cambia con la temperatura esterna.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
